{
  "welcomeBack": "Welcome Back",
  "email": "Email",
  "password": "Password",
  "signupLink": "Create an account ",
  "appLoginText": "Chargement ...",
  "loginLink": "Cliquez ici pour vous connecter",
  "homeLink": "Home",
  "noDispo": "Non disponible pour votre compte",
  "loginButton": "Log in",
  "signUpButton": "Sign Up",
  "forgotPassword": "Forgot Password?",
  "backToLogIn": "Back to Log In",
  "getStarted": "Get Started",
  "resetPassword": "Reset Password",
  "resetPasswordIntro": "Enter your email to reset your password",
  "resetButton": "Reset",
  "resetEmailDone": "Success!  Check your email for a reset link.",
  "auth-weak-password": "Weak password",
  "auth-invalid-email": "The email address is badly formatted.",
  "auth-wrong-password": "The password is invalid or the user does not have a password.",
  "auth-user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
  "auth-internal-error": "Erreur de configuration du serveur d'authentification",

  "profileUpdated": "Profile updated!",
  "profileUpdatedEnterprisePart": "Entreprise du profil mise à jour!",
  "pPseudo": "Pseudo:",
  "pPseudoPH": "Enter your pseudo ...",
  "pPseudoProfilePicture":"Ajouter votre photo",
  "pName": "Name:",
  "pNamePH": "Enter your name ...",
  "pEmail": "Email:",
  "pEmailPH": "Enter your email ...",
  "pPassword": "Password:",
  "pPasswordPH": "Enter your Password (min 6 chars)...",
  "pPhoneNumber": "Phone Number:",
  "pPhoneNumberPH": "Enter your phone number ...",
  "pUserDescription": "Short description about you:",
  "pUserDescriptionPH": "Enter a short description ...",
  "pMandatoryInputHelp": "Obligatoire",
  "pMandatoryAndUnchangeableInputHelp": "Non modifiable - Obligatoire",
  "pAcceptCGU": "J'ai lu et j'approuve les Conditions Générales d'Utilisation et la Politique de confidentialité d'Alomigo disponibles ici.",

  "banUser": "Compte utilisateur bloqué",
  "UserBanned": "Ce compte utilisateur a été bloqué par l'administrateur",
  "UserBannedOnlyAdmin": "Ce compte utilisateur a été bloqué. Il n'est visible que par les administrateurs.",
  "cannotAccessToPrivateUserData": "Ce compte utilisateur est inaccessible (no private user data)",
  "closedUser": "Compte utilisateur clôturé.",
  "UserClosed": "Ce compte utilisateur a été clôturé par son propriétaire",
  "UserClosedOnlyAdmin": "Ce compte utilisateur a été clôturé par son propriétaire. Il n'est visible que par les administrateurs.",

  "InvalidPassword": "Invalid password",
  "InvalidEmail": "Invalid email",
  "InvalidPseudo": "Invalid pseudo",
  "PseudoAlreadyUsed": "Pseudo already used, please select another one!",

  "InvalidPseudoUpperLetter": "First Pseudo letter must be an upper letter.",
  "InvalidPseudoLetterOrNumber": "Only letters or numbers in Pseudo, first an upper letter, then lower letters or numbers.",
  "InvalidPseudoLength": "3 minimum characters in Pseudo.",

  "InvalidAccept": "Vous devez accepter les CGU et la Politique de confidentialité.",

  "closingAccountButtonTitle":"Clôture définitive du compte",
  "closingAccountButton":"Clôture",
  "closingAccountStep2Button":"Confirmer la clôture",
  "closingAccount":"Clôture...",
  "closingAccountTitle":"Clôture de votre compte utilisateur",
  "closingAccountDone":"Clôture de votre compte terminée avec succès",

  "previewProfile":"Preview...",
  "previewProfileTitle":"Preview your profile as your contacts",
  "getInvitationsBasedOnProfile":"Invitations...",
  "getInvitationsBasedOnProfileTitle":"Demander des invitations basé sur votre profil",
  "getInvitationsBasedOnProfileWitheLastDateTitle":
    "Demander des invitations basé sur votre profil (dernière demande: {lastInvitationRequest}, invitation envoyée: {nbInvitationsSent})",
  "enterYourLocationToReceiveInvitations": "Géolocaliser votre profil pour recevoir des invitations pertinentes",
  "viewProfileTitle":"Afficher le profil",
  "viewProfilePromotionTitle":"Afficher la page 'Communication' du profil",
  "loginUsingProfileTitle":"Ouvrir la page de closing avec un login pré-renseigné",

  "paypalUnsubscribeButton":"Unsubscribe",
  "paypalPlanEndedOn":"Your plan will end on: ",

  "missingEmailValidationToAdd": 
  "Ajout impossible car vous n'avez pas validé votre email. Cliquez sur le lien disponible dans votre boîte mail.",
  "missingEmailValidation": 
  "Inscription impossible  car vous n'avez pas validé votre email. Cliquez sur le lien disponible dans votre boîte mail.",
  "missingDataInProfile": "Your profile is incomplete. Check that your name, email, picture and phone number are present in your profile.",
  "missingDataInProfileToAdd": "Ajout impossible car votre profil est incomplet. Vérifiez que vos nom, email, photo et numéro de téléphone sont présents dans votre profil.",
  "itemPublicProfileData": "Informations publiques",
  "itemContactProfileData": "Visibles par vos contacts",
  "itemPrivateProfileData": "Informations privées",
  "itemDefaultProfileData": "Vos préférences",
  "itemBusinessProfileData": "Compte professionnel",
  "cancelCalendarEvent": "Evénement annulé",
  "subscriptionCancelled": "Abonnement annulé",
  "subscriptionUpdated": "Abonnement mis à jour",
  "defaultPictureInPref": "Choisissez une image par défaut.",
  "defaultPictureInPref2": "Utilisée pour les modèles.",
  "resetDefaultsUniversAndCats": "Réinitilisez",
  "resetDefaultsUniversAndCatsTitle": "Réinitilisez le type d'annonce par défaut",
  "defaultDocTypeInPref": "Choisissez un type d'annonce par défaut.",
  "defaultDocTypeInPref2": "Utilisé pour les recherches et les modèles.",
  "defaultLanguage": "Choisissez une langue: ",

  "contactRemoved": "Contact retiré!",
  "appBossTitle": "Boss de l'app!",
  "premiumAccount": "Utilisateur Premium",
  "pContactsList":"La liste de vos contacts:",
  "textConnectedInContactsList":"Connecté ",
  "updateProfileButton":"Enregistrer",
  "updateProfileButtonPH":"Enregistrer les informations"
}
